import { FaWhatsapp } from 'react-icons/fa';
import Navbar from './Navbar';
import Footer from './Footer';
import Services from './Services';
import Habitaciones from './Habitaciones';
import EspaciosComunes from './EspaciosComunes';
import Ubicacion from './Ubicacion';
import ServiciosComunes from './ServiciosComunes';
import Tarifas from './Tarifas';

export default function Home() {
  return <>
    <Navbar />
    <main id="contenido"><Services /><Habitaciones /><EspaciosComunes /><ServiciosComunes /><Tarifas /><Ubicacion /></main>
    <Footer />
    <a href="https://wa.me/5492233555110?text=Hola,%20me%20gustaría%20obtener%20más%20información,%20valores%20y%20disponibilidad." className="whatsapp_float" target="_blank" rel="noopener noreferrer" aria-label="Consultar al Hotel Raglan por WhatsApp"><FaWhatsapp /></a>
  </>;
}
